import { render, staticRenderFns } from "./ResourceYaml.vue?vue&type=template&id=2e33ed8c&scoped=true&"
import script from "./ResourceYaml.vue?vue&type=script&lang=js&"
export * from "./ResourceYaml.vue?vue&type=script&lang=js&"
import style0 from "./ResourceYaml.vue?vue&type=style&index=0&id=2e33ed8c&prod&lang=scss&scoped=true&"
import style1 from "./ResourceYaml.vue?vue&type=style&index=1&id=2e33ed8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e33ed8c",
  null
  
)

export default component.exports